// extracted by mini-css-extract-plugin
export var numberInputContainer = "_5w-0";
export var startPickingButton = "_5w-1";